var _desc, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "gridSmallIconTitle"
  }, "Small Grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "gridSmallIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "gridSmallIconDesc"
  }, "Icon of a small 2-by-2 grid")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 6,
    y: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 13,
    y: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 6,
    y: 13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 13,
    y: 13
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridSmall);
export default __webpack_public_path__ + "static/media/grid-small.6c38aab0acb01a12deba8aa3129e3943.svg";
export { ForwardRef as ReactComponent };